/* global __AUTH_API_URL__ */
import R from 'ramda'

export const AUTH_API_URL = __AUTH_API_URL__

export const sixMonthsInMinutes = 180 * 24 * 60

export const SESSION_LENGTH_VALUES = [
  {text: '15 min', value: 15},
  {text: '30 min', value: 30},
  {text: '1 hour', value: 60},
  {text: '2 hours', value: 120},
  {text: '3 hours', value: 180},
  {text: '1 day', value: 60 * 24},
  {text: '3 days', value: 60 * 24 * 3},
  {text: '1 week', value: 60 * 24 * 7},
  {text: '2 weeks', value: 60 * 24 * 14},
  {text: '1 month', value: 60 * 24 * 30},
  {text: '2 months', value: 60 * 24 * 60},
  {text: '3 months', value: 60 * 24 * 90},
  {text: '6 months', value: 60 * 24 * 180}
]

export const APP_TYPE = {
  BLANK: 'BLANK',
  FULL: 'FULL',
  THIRD_PARTY: 'THIRD_PARTY'
}

export const AC_OWNER_TYPE = {
  RESELLER: 1,
  INSTITUTION: 2
}

export const METHODS = {
  GET: 'get',
  PUT: 'put',
  PATCH: 'patch',
  POST: 'post',
  DELETE: 'delete'
}

export const ENDINGS = {
  START: 'START',
  REQUEST: 'REQUEST',
  PROGRESS: 'PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE'
}
export const SEARCH_ENDINGS = {
  SET_SELECTIONS: 'SET_SELECTIONS',
  CLEAR_SUGGESTIONS: 'CLEAR_SUGGESTIONS'
}

const concatStrings = R.reduce(R.concat, '')
const makeReqObj = (pageName, prefix, endings) => R.map(R.concat(concatStrings([pageName, '_', prefix])), endings)

export const PAGES = {
  USERS: 'users',
  SERIALS: 'serials',
  INSTITUTIONS: 'institutions',
  RESELLERS: 'resellers',
  LICENSES: 'licenses',
  FASTSPRING: 'fastspring/orders',
  API_TOKENS: 'apitokens'
}

export const ACTIONS = {
  AUTH_STATUS: {
    FETCH_ME: makeReqObj('AUTH_STATUS', 'FETCH_ME_', ENDINGS),
    LOGIN: makeReqObj('AUTH_STATUS', 'LOGIN_', ENDINGS),
    LOGOUT: makeReqObj('AUTH_STATUS', 'LOGOUT_', ENDINGS),
    CLEAR_ERROR: 'AUTH_STATUS_CLEAR_ERROR'
  },
  NAVIGATION: {
    GO_TO_TAB: 'NAV_GO_TO_TAB',
    SET_TAB: 'NAV_SET_TAB',
    GO_TO: 'NAV_GO_TO',
    GO_TO_SENT: 'NAV_GO_TO_SENT', // we pass the action on to history.push
    GO_TO_LOGIN: 'NAV_GO_TO_LOGIN'
  },
  // some generic actions we use to
  AUTOCOMPLETE: makeReqObj('PAGE', 'AUTOCOMPLETE_', R.merge(ENDINGS, SEARCH_ENDINGS)),
  FETCH_LIST: makeReqObj('PAGE', 'FETCH_LIST_', ENDINGS),
  FETCH_ONE: makeReqObj('PAGE', 'FETCH_ONE_', ENDINGS), // generic action type for all patch, post, delete on single entities
  FETCH_INSTITUTION: makeReqObj('PAGE', 'FETCH_INSTITUTION_', ENDINGS) // generic action type for all patch, post, delete on single entities
}
export const COLORS = {
  AUTOCOMPLETE: {HIGHLIGHT: '#FFCC00'},
  USERS: {
    MENU: 'grey'
  },
  INSTITUTIONS: {
    MENU: 'grey'
  },
  RESELLERS: {
    MENU: 'grey'
  },
  SERIALS: {
    MENU: 'grey'
  },
  LICENSES: {
    MENU: 'grey'
  },
  FASTSPRING: {
    MENU: 'grey'
  },
  API_TOKENS: {
    MENU: 'grey'
  },
}



// WEBPACK FOOTER //
// ./webAdmin/constants.js